(ns minorodata.sandbox.model
  (:require
   [mold.core :as m]
   [minorodata.users.model :refer [searchable-user]]))

(declare ->pipeline-table ->pipeline-table-preview ->pipeline-group
         ->pipeline-transform ->pipeline-transform-search
         ->pipeline-transform-preview ->pipeline-transform-unsaved
         ->sandbox-version ->sandbox-transform ->live-transform ->pipeline-dag ->sandbox-table
         ->sandbox-preview ->sandbox-updates ->sandbox-transform-execution
         ->pipeline-extract ->commit)

(m/defmodel pipeline-table
  {:id          [::m/string ::m/identity "Qualified name"]
   :table       [::m/string "Table name"]
   :schema      [::m/string "Schema name"]
   :catalog     [::m/string "Catalog name"]

   :columns     [::m/vector ::m/nilable "Vector of columns"]
   :unit-tests  [::m/vector ::m/nilable "Vector of unit tests"]
   :row-count   [::m/number ::m/nilable "Row count"]
   :created-at  [::m/string ::m/nilable "Created at date"]})

(m/defmodel pipeline-table-preview
  {:id      [::m/string ::m/identity "Qualified name"]
   :rows    [::m/vector "Vector of rows"]
   :headers [::m/vector "Vector of columns"]
   :error   [::m/string "Error when fetching the status"]})

(m/defmodel pipeline-transform
  {:id              [::m/identity ::m/req ::m/string "Uniq id"]
   :master-id       [::m/string "Transform master id"]
   :group-id        [::m/string "Group id"]
   :client-id       [::m/string "Client id"]
   :updated-by      {::m/type     ::m/ref
                     ::m/ref-type searchable-user
                     ::m/doc      "Related user"}
   :created-by      {::m/type     ::m/ref
                     ::m/ref-type searchable-user
                     ::m/doc      "Related user"}
   :updated-at      [::m/string "Updated date"]
   :created-at      [::m/string "Created date"]
   :last-run        [::m/string ::m/nilable "Last run date"]
   ;; meta
   :name            [::m/string ::m/nilable "Transform name"]
   :description     [::m/string ::m/nilable "Transform description"]
   :tags            [::m/vector ::m/nilable "Transform tags"]
   :status          [::m/keyword "Transform status"]
   :input-tables    [::m/vector "Input dependencies"]
   :output-tables   [::m/vector "Output dependencies"]
   ;; sql
   :command         [::m/string "Original SQL"]
   :cleaned-command [::m/string ::m/nilable "Cleaned SQL"]
   :statements      [::m/vector ::m/nilable "Cleaned and splitted out SQL"]
   ;; schedule
   :schedule-spec   [::m/map ::m/nilable "{:cron string?}"]
   ;; flags
   :ignore-parser   [::m/bool "Hand written dependencies"]
   :is-full         [::m/bool "Full"]
   :is-temp         [::m/bool "Temp"]
   :stale           [::m/bool "Is this transform are stale"]

   ;; TODO: Make a new model with order and a ref
   :order           [::m/number ::m/nilable "UI only field to preserve the display order"]})

(m/defmodel pipeline-group
  {:id             [::m/string ::m/req ::m/identity "Uniq id"]
   :client-id      [::m/string ::m/req "Client id"]
   :name           [::m/string ::m/nilable "Group name"]
   :description    [::m/string ::m/nilable "Group description"]
   :updated-by     {::m/type     ::m/ref
                    ::m/ref-type searchable-user
                    ::m/doc      "Related user"}
   :created-by     {::m/type     ::m/ref
                    ::m/ref-type searchable-user
                    ::m/doc      "Related user"}
   :updated-at     [::m/string "Timestamp"]
   :created-at     [::m/string "Timestamp"]
   :order          [::m/number "Order in UI"]

   :transforms     {::m/type        ::m/ref
                    ::m/cardinality ::m/many
                    ::m/ref-type    pipeline-transform
                    ::m/doc         "Related transforms"}})

(m/defmodel pipeline-transform-search
  {:query      [::m/string ::m/identity "Query"]
   :transforms {::m/type        ::m/ref
                ::m/cardinality ::m/many
                ::m/ref-type    pipeline-transform
                ::m/doc         "Related transforms"}}
  {:singleton true})

(m/defmodel pipeline-transform-preview
  {:id      [::m/string ::m/identity "Transform id"]
   :command [::m/string "SQL command"]
   :results [::m/vector "Vector of results"]})

(m/defmodel pipeline-transform-unsaved
  {:id          [::m/string ::m/identity "Uniq id"]
   :command     [::m/string "Original SQL"]
   :name        [::m/string ::m/nilable "Transform name"]
   :description [::m/string ::m/nilable "Transform description"]
   :group-id    [::m/string ::m/nilable "Group id"]})

(m/defmodel sandbox-version
  {:version-id [::m/string ::m/identity "Version id"]
   :comment    [::m/string "Version name"]
   :created-at [::m/string "Created at date"]
   :created-by {::m/type     ::m/ref
                ::m/ref-type searchable-user
                ::m/doc      "Related user"}
   :user-id    [::m/string "user"]
   :user-name  [::m/string "User name"]
   :revisions  [::m/vector "Vector of updates"]})

(m/defmodel sandbox-transform
  {:master-id    [::m/string ::m/identity "Transform master id"]
   :transform-id [::m/string "Transform id"]
   :name         [::m/string ::m/nilable "Transform name"]
   :group-id     [::m/string ::m/nilable "Group id"]
   :description  [::m/string ::m/nilable "Transform description"]
   :tags         [::m/vector ::m/nilable "Transform tags"]
   :inputs       [::m/vector "Input dependencies"]
   :outputs      [::m/vector "Output dependencies"]
   :sql          [::m/string ::m/nilable "Original SQL"]

   :order        [::m/number ::m/nilable "UI only field to preserve the display order"]})

(m/defmodel sandbox-transform-execution
  {:master-id   [::m/string ::m/identity "Transform master id"]
   :error       [::m/string ::m/nilable "Error message"]
   :status      [::m/string "Execution status"]})

(m/defmodel live-transform
  {:master-id    [::m/string ::m/identity "Transform master id"]
   :transform-id [::m/string "Transform id"]
   :name         [::m/string ::m/nilable "Transform name"]
   :group-id     [::m/string ::m/nilable "Group id"]
   :description  [::m/string ::m/nilable "Transform description"]
   :tags         [::m/vector ::m/nilable "Transform tags"]
   :inputs       [::m/vector "Input dependencies"]
   :outputs      [::m/vector "Output dependencies"]
   :sql          [::m/string ::m/nilable "Original SQL"]})

(m/defmodel pipeline-dag
  {:id         [::m/string ::m/identity "Transform id or table qualified name"]
   :anchor-id  [::m/string ::m/nilable "Node id the graph is centred on (drives direction/focus)"]
   ;; :nodes/:edges hold the full parsed graph (source of truth, unfiltered).
   :nodes      [::m/vector "Vector of raw parsed nodes"]
   :edges      [::m/vector "Vector of raw parsed edges"]
   ;; :view-nodes/:view-edges hold the filtered + laid-out graph that gets rendered.
   :view-nodes [::m/vector ::m/nilable "Vector of filtered, laid-out nodes"]
   :view-edges [::m/vector ::m/nilable "Vector of filtered, laid-out edges"]
   :filters    [::m/map "Map of filters: :direction :focused? :show-tables?"]})

(m/defmodel sandbox-table
  {:id      [::m/string ::m/identity "Qualified name"]
   :columns [::m/vector ::m/nilable "Vector of columns"]})

(m/defmodel sandbox-preview
  {:id      [::m/string ::m/identity "Qualified name"]
   :preview [::m/vector ::m/nilable "[[col1 col2 ...] [val1 val2 ...] ...]"]})

(m/defmodel sandbox-updates
  {:updates [::m/vector "Vector of updates"]}
  {:singleton true})

(m/defmodel pipeline-extract
  {:extract-id           [::m/string ::m/req ::m/identity "ID"]
   :master-id            [::m/string "Master ID"]
   :client-id            [::m/string "Client ID"]
   :source-id            [::m/string "Source ID"]
   :task-definition-name [::m/string ::m/nilable "Task definition name"]
   :name                 [::m/string "Extract name"]
   :description          [::m/string ::m/nilable "Description"]
   :status               {::m/type ::m/enum
                          ::m/vals #{"active" "paused"}
                          ::m/doc  "Extract status"}
   :output-tables        {::m/type        ::m/string
                          ::m/cardinality ::m/many
                          ::m/doc         "Output tables"}
   :downstream-config    [::m/string ::m/nilable "#{nil 'full'}"]
   :source               [::m/map "Extract configuration json"]
   :updated-at           [::m/string "Timestamp"]
   :created-at           [::m/string "Timestamp"]

   :updated-by           {::m/type     ::m/ref
                          ::m/ref-type searchable-user
                          ::m/doc      "Related user"}
   :created-by           {::m/type     ::m/ref
                          ::m/ref-type searchable-user
                          ::m/doc      "Related user"}

   ;; Temporal schedule
   :schedule-spec        [::m/map ::m/nilable "Schedule spec"]

   :order                [::m/number ::m/nilable "Order of the extract in the panel"]})

(m/defmodel commit
  {:commit-id  [::m/string ::m/req ::m/identity "Commit id"]
   :comment    [::m/string "Commit name"]
   :created-at [::m/string "Created at date"]
   :created-by {::m/type     ::m/ref
                ::m/ref-type searchable-user
                ::m/doc      "User who made the commit"}

   :revision [::m/vector "Vector of revisions"]

   :order [::m/number ::m/nilable "UI only field to preserve the display order"]})
